import { Component, ViewEncapsulation, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tr-virtual-keyboard-button' ,
  templateUrl: './tr-virtual-keyboard-button.component.html',
  styleUrls: [ './tr-virtual-keyboard-button.component.scss' ],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrVirtualKeyboardButtonComponent {

    @Input() public value: number;
    @Input() public disabled: boolean;
    @Input() public prefix: string = 'R$';
    @Input() public precision: number = 2;
    @Output() public onClicked: EventEmitter<number> = new EventEmitter();

    public get labelValue(): number {
        return this.value >= 0 ? this.value : -this.value;
    }

    /** Handler para o evento de clique do botão */
    public onClickHandler(event: Event) {

        if (!this.disabled) {
            event.stopPropagation();
            this.onClicked.emit(this.value);
        }
    }

}
